import { api } from ".";

export const fetchSongs = async (page = 0, size = 10): Promise<ApiResponse<Songs>> => {
  const res = await api.get<ApiResponse<Songs>>(`/songs?type=Audio&pageSize=${size}&page=${page}`);
  return res.data;
};

export const searchSongs = async (query = "", page = 0, size = 10): Promise<ApiResponse<Songs>> => {
  const res = await api.get<ApiResponse<Songs>>(
    `/songs/search?searchKey=${query}&pageSize=${size}&page=${page}`
  );
  return res.data;
};

export const fetchNewSongs = async (page = 0, size = 10): Promise<ApiResponse<Songs>> => {
  const res = await api.get<ApiResponse<Songs>>(`/songs/new?pageSize=${size}&page=${page}`);
  return res.data;
};

export const fetchPopularSongs = async (page = 0, size = 10): Promise<ApiResponse<Songs>> => {
  const res = await api.get<ApiResponse<Songs>>(`/songs/popular?pageSize=${size}&page=${page}`);
  return res.data;
};
